export default [
  {
    path: '/main/reportlastpositions',
    meta: {
      tag: 'report_lastpositions',
      name: 'Últimos Posicionamentos',
      breadcrumb: 'Últimos Posicionamentos'
    },
    component: () => import(/* webpackChunkName: "report-lastpositions" */ '@/views/main/reports/lastpositions/Index.vue'),
    children: [
      {
        path: '',
        name: 'listlastpositions',
        meta: {
          tag: 'report_lastpositions',
          name: 'Últimos Posicionamentos',
          menu: 'reports',
        },
        component: () => import(/* webpackChunkName: "report-lastpositions" */ '@/views/main/reports/lastpositions/List.vue'),
      }
    ]
  }
]  